import { FlussDefinition } from "modules/fluss/types/fluss";
import { QueueOption } from "../fluss-builder-types";

export interface FlussMetadataOption {
    id: string;
    name: string;
    label?: string;
    code?: string;
    table_name?: string;
    value?: string;
    active?: boolean;
    column_type?: string;
    payload_example?: string;
    is_mandatory?: boolean;
    referenced_table_name?: string;
    sys_table_id?: string | { id?: string };
    sys_group_id?: string | { id?: string };
    sys_role_id?: string | { id?: string };
    title?: string;
    target_table?: string;
    published?: boolean;
    icon?: string;
    business_rule?: string | { id?: string };
    params_schema?: string;
    output_schema?: string;
    order?: number;
    description?: string;
}

export interface ManualTriggerBusinessRuleOption extends FlussMetadataOption {
    is_manual_trigger_candidate: boolean;
    is_managed: boolean;
    is_update_trigger: boolean;
}

export interface FlussNodePanelData {
    tables: FlussMetadataOption[];
    businessRules: FlussMetadataOption[];
    manualTriggerBusinessRules: ManualTriggerBusinessRuleOption[];
    roles: FlussMetadataOption[];
    // PRIM-023 (round 6): raw groups + sys_group_roles memberships, alongside `roles` and
    // `queues` — QueueSelect joins these itself to build the Roles/Grupos accordions instead of
    // `queues` (queueOptions' pre-joined, one-entry-per-role list) doing it, so a role linked to
    // more than one group can show up once per group instead of collapsing to the first match.
    groups: FlussMetadataOption[];
    groupRoles: FlussMetadataOption[];
    factoryActions: FlussMetadataOption[];
    apiSecrets: FlussMetadataOption[];
    schedules: FlussMetadataOption[];
    queues: QueueOption[];
    templates: FlussMetadataOption[];
    eventTypes: FlussMetadataOption[];
    serviceForms: FlussMetadataOption[];
    // Fase 12 (D1): call_activity's "Process" selector — real Fluss::Definition rows, not a
    // sys_* metadata catalog entry (Fluss::Api::MetadataController's whitelist is for
    // SysRecord-backed tables only; definitions are a native ActiveRecord model).
    definitions: FlussDefinition[];
}

export const referenceId = (value: unknown) => {
    if (value && typeof value === "object" && "id" in value) {
        return String((value as { id?: unknown }).id || "");
    }
    return value ? String(value) : "";
};
